var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtgrGamer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 11.6886V16.0427C18.3406 16.1446 18.3233 16.2468 18.2831 16.3406C18.2222 16.4883 18.1084 16.6079 17.9641 16.6761L12.9572 19.0411C12.3453 19.3301 11.6769 19.48 11.0001 19.48C10.3234 19.48 9.65502 19.3301 9.04306 19.0411L4.03623 16.6761C3.91807 16.6201 3.81968 16.5296 3.75405 16.4165C3.68842 16.3034 3.65864 16.1731 3.66864 16.0427V11.6886M9.16681 4.81356C9.16681 5.29979 9.35996 5.7661 9.70378 6.10992C10.0476 6.45374 10.5139 6.64689 11.0001 6.64689C11.4864 6.64689 11.9527 6.45374 12.2965 6.10992C12.6403 5.7661 12.8335 5.29979 12.8335 4.81356C12.8335 4.32733 12.6403 3.86101 12.2965 3.5172C11.9527 3.17338 11.4864 2.98022 11.0001 2.98022C10.5139 2.98022 10.0476 3.17338 9.70378 3.5172C9.35996 3.86101 9.16681 4.32733 9.16681 4.81356Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.6469V12.1469M4.06177 11.4282L9.22627 9.29056C10.3623 8.8215 11.6378 8.8215 12.7738 9.29056L17.9383 11.4282C18.0527 11.475 18.1509 11.5541 18.221 11.656C18.291 11.7578 18.3298 11.8779 18.3325 12.0014C18.3352 12.125 18.3018 12.2467 18.2363 12.3515C18.1708 12.4563 18.0762 12.5397 17.9639 12.5915L12.9571 14.9226C12.3441 15.2078 11.6761 15.3557 11 15.3557C10.3239 15.3557 9.65593 15.2078 9.04293 14.9226L4.0361 12.5915C3.92325 12.5402 3.82794 12.4568 3.76199 12.3519C3.69604 12.2469 3.66234 12.1249 3.66507 12.0009C3.6678 11.877 3.70685 11.7566 3.77736 11.6546C3.84788 11.5526 3.94676 11.4745 4.06177 11.4282Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtgrGamer);
export default __webpack_public_path__ + "static/media/ctgr-gamer.0dd9ef8785c4dfad76ec6acc9e70f47a.svg";
export { ForwardRef as ReactComponent };